import { useState } from "react";
import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import { SettingsInputAntennaOutlined } from "@mui/icons-material";

import { useAuthContext } from "../../context/auth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { ConfirmDialog } from "../dialogKit";

const MODE_LABELS = { M1: "Mode 1", M2: "Mode 2", M3A: "Mode 3/A" };

const Delete = ({ id, code, countryISO, mode, onDeleted }) => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuthContext();

  const [show, setShow] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError("You must be logged in");
      return;
    }

    if (!id) {
      setError("SIF code ID is missing");
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await axiosPrivate.delete(`/api/sifcodes/${id}`);

      if (onDeleted) {
        onDeleted(id, response.data);
      }

      setShow(false);
    } catch (error) {
      console.error("Failed to delete SIF code:", error);

      setError(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to delete SIF code"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete SIF code">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => {
            setError(null);
            setShow(true);
          }}
          disabled={loading}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={loading}
        error={error}
        title="Delete SIF code?"
        message="Targets reporting this code will no longer be identified by it."
        item={`SIF ${code}`}
        itemDetail={[MODE_LABELS[mode] || mode, countryISO].filter(Boolean).join(" · ")}
        itemIcon={SettingsInputAntennaOutlined}
        confirmLabel="Delete SIF code"
      />
    </>
  );
};

export default Delete;
